(function () {
    'use strict';

    angular.module('app').factory('enumService', EnumServiceFactory);

    /**
     * List all codes used in angularjs controllers/directives/components below
     */
    EnumServiceFactory.$inject = [];
    function EnumServiceFactory() {
        const apps = Object.freeze({
            'Person': 'BET',
            'VO': 'VO',
            'NVO': 'NVO',
            'COL': 'COL',
        });

        const notificationTypes = Object.freeze({
            'DossierOrganisationComment': 0,
            'DossierPersonComment': 1,
            'IvmComment': 3,
            'FvmComment': 4,
        });

        const DashboardDocumentType = Object.freeze({
            'FVM': 0,
            'IVM_StandAloneOrLinkedToFVM': 1,
            'IVM_ExpiredLogins': 10,
            'IVM_SignedNotSeenBySo': 11,
            'IvmAfterRejected': 12,
            'IVM': 15,
            'NewSecurityOfficer': 16,
            'OldHabilSignedBVLNotSeenBySo': 17,
            'DossiersToStop': 18,
            'InstallationRequests': 19,
            'IVM_ConfirmStopScreenings': 20,
            'FindingsAndDecision': 21,
            'QueuedStateIvms': 22,
            'CisRequests': 23,
            'OnHoldPscRequest': 24,
            'OnHoldPscRequestForeign': 25,
            'OnHoldFscRequest': 26,
            'ContactPersonRequests': 27,
            'PscisRequests': 28,
        });

        const screeningTypeCode = Object.freeze({
            'FVM': 10,
            'IVM': 20,
            'CertificateOut': 30,
            'SecurityCheck': 40,
            'PhysicalInstallation': 50, 
            'CIS': 60,
            'PersonReinvestigation': 276,
        });

        const screeningResultCode = Object.freeze({
            'RAS': 10,
            'RASabroad': 11,
            'SecurityCheck': 12,
            'RASrevision': 13,
            'Retour': 20,
            'Report': 30,
            'ReportedClassified': 31,
            'AdministrativeRefusal': 40,
            'AlternativeMeasure': 50,
        });

        const screeningStatusCode = Object.freeze({
            'New': 10,
            'Retour': 20,
            'Accepted': 30,
            'Completed': 40,
            'Confirmed': 50,
            'Processed': 60,
            'Stopped': 61,
            'Rejected': 70,
            'ReadOnly': 80,
        });

        const ivmInitialActions = Object.freeze({
            'New': 20,
            'Change': 21,
            'Renew': 22,
            'Remove': 23
        });

        const fvmInitialActions = Object.freeze({
            'New': 10,
            'Change': 11,
            'Renew': 12,
            'Remove': 13,
        });

        const ivmStatusCodes = Object.freeze({
            'InPreparationInitial': 10,
            'AtNVOforinvolved': 18,
            'AtNVOforVO': 19,
            'WithInvolved': 20,
            'RefusedByInvolved': 21,
            'WithSO': 22,
            'WithNVO': 25,
            'Archived': 28,
            'BasicChange': 29,
            'Completed': 30,
            'SendtoSO': 31,
            'NewInitialQuestionnaire': 40,
            'RetourIVMByNVO': 41,
            'AdministrativeRefusalCommunicated': 50,
            'OK': 60,
            'InvoiceSent': 64,
            'BVLPaid': 65,
            'ScreeningOngoing': 130,
            'AssistanceINStarted': 131,
            'SentBackByCOL': 140,
            'Conductedscreening': 150,
            'Reported': 160,
            'AdministrativelyRefused': 161,
            'AcceptedWithoutScreening': 168,
            'Accepted': 170,
            'AcceptedForeign': 175,
            'AcceptedWithLimitation': 180,
            'AcceptedWithAlternativeMeasure': 181,
            'Refused': 190,
            'RefusedCommunicated': 191,
            'ScreeningStopped': 192,
            'ConfirmStopScreening': 193,
            'ConfirmationGivenToStopScreening': 194,
            'Signed': 200,
            'SignedWithLimitation': 210,
            'Appealed': 220,
            'Cancelled': 230,
            'SecurityClearanceWithdrawn': 231,
            'Double': 240,
            'LinkedToNSADummy': 300
        });

        const fvmStatusCodes = Object.freeze({
            'InpreparationInitial': 10,
            'ChangeStarted': 11,
            'InvoiceSent': 64,
            'SignatureInvitationSend': 69,
            'SentPhase1': 70,
            'ChangeSent': 71,
            'Phase1NOK': 80,
            'ChangeNOK': 81,
            'Phase1OK': 90,
            'Sentphase2': 100,
            'RetourFVMbyNVO': 101,
            'Phase2NOK': 110,
            'Phase2OK': 120,
            'Phase2OKNoEffect': 121,
            'ChangeOK': 122,
            'PaidFVM': 125,
            'ScreeningOngoing': 130,
            'SentBackByCOL': 140,
            'Conductedscreening': 150,
            'Reported': 160,
            'Accepted': 170,
            'AcceptedWithoutScreening': 168,
            'AcceptedWithLimitation': 180,
            'Refused': 190,
            'Refusedcommunicated': 191,
            'ScreeningStopped': 192,
            'ConfirmStopScreening': 193,
            'ConfirmationGivenToStopScreening': 194,
            'Signed': 200,
            'Signedwithlimitation': 210,
            'Appealed': 220,
            'Cancelled': 230,
            'SecurityClearanceWithdrawn': 231,
            'Double': 240,
            'ChangeWithoutEffect': 201,
            'ConfirmationGivenToStopScreening': 194
        });

        const HomologationStatusCodes = Object.freeze({
            'InpreparationInitial': 10,
            'NewInitialQuestionnaire': 40,
            'RequestSentBackByNsa': 51,
            'OK': 60,
            'InvoiceSent': 64,
            'Paid': 126,
            'ScreeningOngoing': 130,
            'SentBackByCOL': 140,
            'Reported': 160,
            'Accepted': 170,
            'ScreeningStopped': 192,
            'ConfirmStopScreening': 193,
            'ConfirmationGivenToStopScreening': 194,
            'Signed': 200,
        });

        const civilStatusCodes = Object.freeze({
            'Unmarried': 10,
            'Married': 20,
            'PartnerNotLivingTogether': 30,
            'PartnerLivingTogether': 35,
            'Widowed': 50,
            'Separated': 60,
            'SeparationFromBed': 80,
            'Partnership': 110,
            'Undetermined': 130
        });

        const personStatusCodes = Object.freeze({
            KBO: 10,
            User: 20,
            UserBlock: 30
        });

        const personActionCodes = Object.freeze({
            StartIVM: 'StartIVM',
            NoAcknowledgement: 'NoAcknowledgement',
            NoAction: 'NoAction',
            ActionRequired: 'ActionRequired'
        });

        const colDashboardNumberType = Object.freeze({
            GetToAcceptFVM: 0,
            GetToAnswerFVM: 1,
            GetToSignFVM: 2,
            GetToAcceptIVM: 3,
            GetToAnswerIVM: 4,
            GetToSignIVM: 5,
            GetConfirmStopScreenings: 6,
            GetToReturnFVM: 7,
            GetRejectedFVM: 8,
            GetConfirmStopScreeningsFVM: 9,
            GetToAcceptIVMAssistanceIN: 10,
            GetToAnswerIVMAssistanceIN: 11,
            GetToSignIVMAssistanceIN: 12,
            GetRevisionsFSC: 13,
            GetPersonReinvestigationsToAnswer: 14,
            GetPersonReinvestigationsToSign: 15,
            InstallationScreeningsToAccept: 20,
            InstallationScreeningsToAnswer: 21,
            InstallationScreeningsToSign: 22,
            CisScreeningsToAccept: 30,
            CisScreeningsToAnswer: 31,
            CisScreeningResultsToConfirm: 32,
        });

        const governmentOrganisationTypes = Object.freeze({
            NVO: 20,
            Collegiaal: 30,
            Government: 40,
            InternationalInstitution: 50,
            ForeignNSA: 60,
            PrivateLegalEntity: 80,
        });

        const organisationTypes = Object.freeze({
            'Organisation': 10,
            'Branch': 15,
            'Independent': 90,
            ...governmentOrganisationTypes,
        });

        const VMLevels = Object.freeze({
            'None': 1,
            'Restricted': 5,
            'Confidential': 10,
            'Secret': 20,
            'Topsecret': 30,
            'Atomal': 40,
            'Atomic': 50,
        });
        
        const attachmentTypes = Object.freeze({
            'AanvraagFVMfase1origin': 10,
            'AanvraagFVMfase1klant': 11,
            'AanvraagFVMfase2Bevestigenakkoordopstartenveiligheidsonderzoekorigin': 20,
            'AanvraagFVMfase2Bevestigenakkoordopstartenveiligheidsonderzoekklant': 21,
            'OfferteContract': 30,
            'Jaarrekening': 50,
            'CommercialDoc': 51,
            'Statuten': 52,
            'Appendixconcerningassessment': 53,
            'Otherdocuments': 54,
            'Patrimonium': 55,
            'ConfirmationTransferDocument': 99,
            'ResultPersonalActionDocumentorigin': 100,
            'ResultPersonalActionDocumentklant': 101,
            'ResultPersonalActionDocumentfoto': 102,
            'ResultPersonalActionDocumentSO': 103,
            'Verklaringgeenkennisname': 110,
            'Invoice': 120,
            'Creditnote': 121,
            'Portrait': 130,
            'ForeignDocument': 140,
            'ForeignDocumentSigned': 141,
            'VerificationAttest': 142,
            'RefusalLetter': 143,
            'LimitationLetter': 144,
            'Document': 150,
            'FSCIS': 160,
            'HomologationJustification': 161,
            'HomologationSummary': 162,
            'HomologationCertificate': 163,
            'DeclarationOfConformity': 164,
            'ForeignCertificate': 193,
            'IVMAcknowledgement': 200,
            'ExclusivityDocument': 210,
            'EmploymentContract': 211,
            'Explanatorynote': 500,
            'NoAcknowledgement': 501,
            'RequestSecurityOfficer': 502,
            'TemporaryNoAcknowledgementDocument': 503,
            'NsaSecurityBriefing': 600,
            'CompanySecurityBriefing': 601,
            'PaymentImport': 800,
            'VerifImport': 810,
            'VerifPdfExport': 820,
            'VerifScreeningExport': 830,
            'FirmScreeningExport': 890,
            'ScreeningExport': 900,
            'Instructions': 905,
            'AgendaExport': 910,
            'Registration': 920,
            'Signedregistration': 921,
            'ScreeningAssistResponse': 930,
            'ScreeningCertificateResponse': 931,
            'ScreeningAssistRequest': 932,
            'ScreeningCertificateRequest': 933,
            'ScreeningDocument': 935,
            'ScreeningResultDocument': 936,
            'RequestAssistQuestion': 940,
            'RequestCertificateQuestion': 941,
            'DecisionAppealBody': 942,
            'Certificate': 943,
            'InadmissibleLetter': 950,
            'TemplateIntern': 997,
            'TemplateExtern': 998,
            'Temp': 999
        });

        const justificationPhases = Object.freeze({
            Contract: 1,
            Quote: 2
        });

        const securityIncidentStatus = Object.freeze({
            New: 10,
            Accepted: 20,
            Rejected: 30,
            Treated: 40,
        });

        const addressTypes = Object.freeze({
            Woonplaats: 10,
            Werkelijkeverblijfplaats: 20,
            Tweedeverblijfplaats: 30,
            Voorgaandadres: 40,
            Toekomstigadres: 50,
            AddressHeadoffice: 101,
            AddressBranch: 102,
            BranchinBelgiumforforeigncompany: 103,
            InvoiceAddress: 110,
        });

        const httpCodes = Object.freeze({
            CONTINUE: 100,
            SWITCHING_PROTOCOLS: 101,
            PROCESSING: 102,
            EARLY_HINTS: 103,
            OK: 200,
            CREATED: 201,
            ACCEPTED: 202,
            NON_AUTHORITATIVE_INFORMATION: 203,
            NO_CONTENT: 204,
            RESET_CONTENT: 205,
            PARTIAL_CONTENT: 206,
            MULTI_STATUS: 207,
            ALREADY_REPORTED: 208,
            IM_USED: 226,
            MULTIPLE_CHOICES: 300,
            MOVED_PERMANENTLY: 301,
            FOUND: 302,
            SEE_OTHER: 303,
            NOT_MODIFIED: 304,
            USE_PROXY: 305,
            TEMPORARY_REDIRECT: 307,
            PERMANENT_REDIRECT: 308,
            BAD_REQUEST: 400,
            UNAUTHORIZED: 401,
            PAYMENT_REQUIRED: 402,
            FORBIDDEN: 403,
            NOT_FOUND: 404,
            METHOD_NOT_ALLOWED: 405,
            NOT_ACCEPTABLE: 406,
            PROXY_AUTHENTICATION_REQUIRED: 407,
            REQUEST_TIMEOUT: 408,
            CONFLICT: 409,
            GONE: 410,
            LENGTH_REQUIRED: 411,
            PRECONDITION_FAILED: 412,
            PAYLOAD_TOO_LARGE: 413,
            URI_TOO_LONG: 414,
            UNSUPPORTED_MEDIA_TYPE: 415,
            RANGE_NOT_SATISFIABLE: 416,
            EXPECTATION_FAILED: 417,
            IM_A_TEAPOT: 418,
            MISDIRECTED_REQUEST: 421,
            UNPROCESSABLE_ENTITY: 422,
            LOCKED: 423,
            FAILED_DEPENDENCY: 424,
            TOO_EARLY: 425,
            UPGRADE_REQUIRED: 426,
            PRECONDITION_REQUIRED: 428,
            TOO_MANY_REQUESTS: 429,
            REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
            UNAVAILABLE_FOR_LEGAL_REASONS: 451,
            INTERNAL_SERVER_ERROR: 500,
            NOT_IMPLEMENTED: 501,
            BAD_GATEWAY: 502,
            SERVICE_UNAVAILABLE: 503,
            GATEWAY_TIMEOUT: 504,
            HTTP_VERSION_NOT_SUPPORTED: 505,
            VARIANT_ALSO_NEGOTIATES: 506,
            INSUFFICIENT_STORAGE: 507,
            LOOP_DETECTED: 508,
            BANDWIDTH_LIMIT_EXCEEDED: 509,
            NOT_EXTENDED: 510,
            NETWORK_AUTHENTICATION_REQUIRED: 511
        });

        const screeningServices = Object.freeze({
            FODECO: 'FOD_ECO',
            VSSE: 'VSSE',
            ADIVSGRS: 'ADIV-SGRS'
        });

        const dossierStatusCodes = Object.freeze({
            New: 10,
            Open: 20,
            Archived: 30,
            Imported: 40,
            ImportAmbiguous: 50,
            Blocked: 60,
            DossierDeletion: 70
        });

        const requestTypes = Object.freeze({
            FVM: 'FVM',
            IVM: 'IVM',
            Installation: 'Installation',
            StandaloneCis: 'StandaloneCis'
        });

        const finalResults = Object.freeze({
            NotSet: 0,
            Awarded: 10,
            AwardedLimited: 20,
            Rejected: 30,
            DecisionByAppealBody: 40,
            ToBeVerified: 99,
        });

        const ContactPersonRequestStatusCodes = Object.freeze({
            Created: 10,
            Submitted: 20,
            SentBack: 30,
            DeclaredAdmissible: 40,
            VerificationStarted: 50,
            Approved: 100,
            Rejected: 101,
            Aborted: 110,
        });

        const Genders = Object.freeze({
            Unknown: 0,
            Male: 1,
            Female: 2,
            Other: 3,
        });

        const PscisRequestStatusCodes = Object.freeze({
            Created: 10,
            Submitted: 20,
            SentBack: 30,
            DeclaredAdmissible: 40,
            Finished: 100,
            Rejected: 101,
            Aborted: 110,
        });

        const LivingArrangements = Object.freeze({
            NotCohabitating: "10",
            CohabitatingLessThan10Years: "20",
            CohabitatingAtLeast10Years: "30",
        });

        const ClearanceStatusCodes = Object.freeze({
            Active: 10,
            Inactive: 20,
            Ended: 30,
        });

        const CisAdministratorTypeCode = Object.freeze({
            InternalAdministrator: 0,
            ExternalAdministrator: 1,
            ManagedServiceProvider: 2,
        });

        const AgendaStatusCodes = Object.freeze({
            Initial: 10,
            Forwarded: 20,
            Updated: 30,
            Closed: 40,
        });

        const AgendaResultCodes = Object.freeze({
            Initial: 10,
            Accepted: 20,
            AcceptedWithLimitation: 30,
            Deferred: 40,
            Refused: 50,
        });

        return Object.freeze({
            Apps: apps,
            AttachmentTypes: attachmentTypes,
            NotificationTypes: notificationTypes,
            DashboardDocumentType,
            ScreeningTypeCode: screeningTypeCode,
            ScreeningResultCode: screeningResultCode,
            ScreeningStatusCode: screeningStatusCode,
            SecurityIncidentStatus: securityIncidentStatus,
            IvmInitialActions: ivmInitialActions,
            FvmInitialActions: fvmInitialActions,
            IvmStatusCodes: ivmStatusCodes,
            FvmStatusCodes: fvmStatusCodes,
            CivilStatusCodes: civilStatusCodes,
            PersonStatusCodes: personStatusCodes,
            PersonActionCodes: personActionCodes,
            ColDashboardNumberType: colDashboardNumberType,
            OrganisationTypes: organisationTypes,
            GovernmentOrganisationTypes: governmentOrganisationTypes,
            VMLevels,
            JustificationPhases: justificationPhases,
            AddressTypes: addressTypes,
            HttpCodes: httpCodes,
            ScreeningServices: screeningServices,
            DossierStatusCodes: dossierStatusCodes,
            RequestTypes: requestTypes,
            FinalResults: finalResults,
            HomologationStatusCodes,
            ContactPersonRequestStatusCodes,
            Genders,
            PscisRequestStatusCodes,
            LivingArrangements,
            ClearanceStatusCodes,
            CisAdministratorTypeCode,
            AgendaStatusCodes,
            AgendaResultCodes,
        });
    }
})();
